import { User, Profile, UpdateUser } from '@/_models/User';
import { UserService } from "@/services/UserService";
import store from '@/store/index';
import { Helper } from "@/utils/Helper";

export class UserUtils{

  static async fetchProfile ():Promise<Profile> {
    const userObj = store.getters['auth/user'];
    let profile:Profile;

    try{
      const userService = new UserService();
      const userDetail:User = await userService.getUser(userObj.userId);
      profile = {
        firstName: userDetail.xarcadeUser.firstName,
        lastName: userDetail.xarcadeUser.lastName,
        username: userDetail.xarcadeUser.username,
        email: userDetail.xarcadeUser.email,
        gender: userDetail.xarcadeUser.gender,
        country: userDetail.xarcadeUser.country,
        websiteUrl: userDetail.xarcadeUser.websiteUrl,
        socialMedia: userDetail.xarcadeUser.socialMedia,
        profilePicture: userDetail.xarcadeUser.profilePicture,
      }
    }catch(error){
      profile = {
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        gender: '',
        country: '',
        websiteUrl: '',
        socialMedia: [],
        profilePicture: '',
      }
      Helper.endpointErrorHandling(error);
    }
    return profile;
  }

  static async updateUserProfile (firstName:string, lastName:string, gender:string, country:string, websiteUrl:string, twitter:string, discord:string):Promise<UpdateUser>{
    const formData = new FormData();
    formData.append('FirstName', firstName);
    formData.append('LastName', lastName);
    formData.append('Gender', gender);
    formData.append('Country', country);
    formData.append('WebsiteUrl', websiteUrl);
    formData.append('Twitter', twitter);
    formData.append('Discord', discord);

    const userObj = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken']
    try {
      const userService = new UserService();
      const updateUser = await userService.updateUser(userObj.userId, jwtToken, formData)
      if(updateUser.success){
        return {
          message: updateUser.message,
          success: true,
        }
      }else{
        return {
          message: updateUser.message,
          success: false,
        }
      }
    } catch (error) {
      Helper.endpointErrorHandling(error);
      return {
        message: error,
        success: false,
      }
    }
  }

  static async fetchApiKey(gameId: string):Promise<string>{
    const userService = new UserService();
    const apiKey:string = await userService.getGameApiKey(gameId);
    return apiKey;
  }
}